module.exports = __webpack_public_path__ + "static/media/prices.3a528919.jpeg";